// Module
var code = "<organism-wizard-confirm-view service-wizard-confirm=\"$ctrl.webspaceWizardConfirmation\" wizard-create-object-list=\"$ctrl.wizardCreateObjectList\"></organism-wizard-confirm-view> ";
// Exports
module.exports = code;